import Vibrant from '@vibrant/core'

Vibrant.DefaultOpts.quantizer = 'mmcq'
Vibrant.DefaultOpts.generators = ['default']
Vibrant.DefaultOpts.filters = ['default']

export default Vibrant
